import React, {useEffect, useState} from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useTokenStore from "../Store/Store";
import { useCookies } from 'react-cookie';

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        position:fixed;
        top:0px;
        background-color:#000000;
        opacity:50%;
        z-index:4;
    `,
    WrapBox:styled.div`
        width:100%;
        height:90%;
        background-color:#ffffff;
        position:fixed;
        top:15%;
        z-index:5;
        border-radius:20px 20px 0px 0px;
        display:flex;
        justify-content:space-between;
        align-items:center;
        flex-direction:column;
    `,
        Header:styled.div`
            width:100%;
            height:60px;
            display:flex;
            justify-content:center;
            align-items:center;
            flex-direction:column;
        `,
            HeaderText:styled.p`
                font-size:18px;
                font-weight:600;
                margin:0px;
                font-family:'PreFont';
            `,

        ConTentWrap:styled.div`
            width:90%;
            height:70%;
            display:flex;
            justify-content:space-around;
            align-items:center;
            flex-direction:row;
            flex-wrap:wrap;
        `,
            ContentBox:styled.div`
                width:48%;
                height:23%;
                border-radius:10px;
                background-color:#F2F2F7;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                font-size:20px;
                font-weight:600;
                color:#030303;
                margin:0px;
                font-family:'PreFont';
                &:hover{
                    background-color:#2277F6;
                    font-size:20px;
                    font-weight:600;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                }
            `,

        Footer:styled.div`
            width:100%;
            height:100px;
            display:flex;
            justify-content:center;
            align-items:flex-start;
            flex-direction:row;
            margin-bottom:10px;
            box-shadow: 0px 0px 20px #eeeeee;
        `,
            CallBtn:styled.div`
                width:90%;
                height:50px;
                border-radius:10px;
                background-color: ${({ isActive }) => (isActive ? "#2277F6" : "#999999")};
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                margin-top:10px;
            `,
                BtnText:styled.p`
                    font-size:16px;
                    font-weight:400;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                `,
}
const CallService=(props)=>{
    const {CallOpen, setCallOpen, NowLang} = props
    const [Title, setTitle] = useState({
        "KR":"요청사항을 선택해주세요",
        "EN":"Please select your request",
        "CN":"请选择请求事项",
        "JP":"追加メニューを選択してください",
        "FR":"Veuillez sélectionner votre demande",
        "SP":"selecciona tu solicitud",
        "GR":"Bitte wählen Sie Ihre Anfrage aus",
        "RU":"Пожалуйста, выберите ваш запрос"
    })
    const [ChoiceMenu, setChoiceMenu] = useState([
        {
            "KR":"수저",
            "EN":"tableware",
            "CN":"汤匙和筷子",
            "JP":"お箸とスプーン",
            "FR":"couverts",
            "SP":"cubiertos",
            "GR":"Besteck",
            "RU":"посуда"
        }, 
        {
            "KR":"앞접시",
            "EN":"side plate",
            "CN":"围裙",
            "JP":"取り皿",
            "FR":"tablier",
            "SP":"delantal",
            "GR":"Schürze",
            "RU":"фартук"
        }, 
        {
            "KR":"가스버너",
            "EN":"gas burner",
            "CN":"燃气灶",
            "JP":"ガスコンロ",
            "FR":"gaz",
            "SP":"hornillo de gas",
            "GR":"Gasherd",
            "RU":"газовая плита"
        }, 
        {
            "KR":"가위",
            "EN":"scissors",
            "CN":"剪刀",
            "JP":"はさみ",
            "FR":"ciseaux",
            "SP":"tijeras",
            "GR":"Schere",
            "RU":"ножницы"
        }, 
        {
            "KR":"물",
            "EN":"water",
            "CN":"一瓶水",
            "JP":"水",
            "FR":"eau",
            "SP":"agua",
            "GR":"Wasser",
            "RU":"вода"
        }, 
        {
            "KR":"반찬",
            "EN":"side dishes",
            "CN":"配菜",
            "JP":"おかず",
            "FR":"accompagnement",
            "SP":"guarnición",
            "GR":"Beilage",
            "RU":"гарнир"
        }, 
        {
            "KR":"앞치마",
            "EN":"apron",
            "CN":"围裙",
            "JP":"エプロン",
            "FR":"tablier",
            "SP":"delantal",
            "GR":"Schürze",
            "RU":"фартук"
        }, 
        {
            "KR":"직접입력",
            "EN":"Direct input",
            "CN":"直接输入",
            "JP":"直接入力",
            "FR":"saisie directe",
            "SP":"entrada directa",
            "GR":"Direkt eingeben",
            "RU":"Прямой ввод"
        }
    ])
    const [SelectBtn, setSelectBtn] = useState({
        "KR":"호출하기",
        "EN":"Call",
        "CN":"呼叫",
        "JP":"呼び出し",
        "FR":"Appeler",
        "SP":"Llamar",
        "GR":"Rufen",
        "RU":"Вызов"
    })
    const [Choice, setChoice] = useState("")
    const navigate = useNavigate();

    const [Restaurant_PK, setRestaurant_PK] = useState(undefined)
    const [Table_PK, setTable_PK] = useState(undefined)
    const [IDcookies, setIDcookies, removeIDcookies] = useCookies(["restaurant_id"]);

    useEffect(() => {
        if (IDcookies["restaurant_id"]) {
            const first = IDcookies["restaurant_id"].substring(0, 36);     // 앞 절반
            const second = IDcookies["restaurant_id"].substring(36);       // 뒤 절반
        
            setRestaurant_PK(first);
            setTable_PK(second);
            console.log(IDcookies["restaurant_id"])
        } else {
            console.log("ID 값이 없습니다.");
        }
    }, [IDcookies["restaurant_id"]]);

    const axiosInstance = axios.create({
        baseURL: 'https://zzikgomainapi.co.kr/',
    });
    const CallApi = async () => {
        setCallOpen(false)        
        try {
            const response = await axiosInstance.post("orders/customer-request/", {
                "table":Table_PK,
                "restaurant":Restaurant_PK,
                "request_contents":Choice,
                "comment":Choice
            });
            console.log(response.data)
        } catch (error) {
            console.error(error); // 요청에 실패한 경우 에러 메시지 출력
        }
    }

    if(CallOpen === false){
        return(
            <></>
        )
    }else{
        return(
            <>
                <Styled.Wrap onClick={()=>{setCallOpen(false)}}/>
                <Styled.WrapBox>
                    <Styled.Header>
                        <Styled.HeaderText>{Title[NowLang]}</Styled.HeaderText>
                    </Styled.Header>
                    <Styled.ConTentWrap>
                        {ChoiceMenu.map((v)=>{
                            return(
                                <Styled.ContentBox onClick={()=>{setChoice(v["KR"])}}>{v[NowLang]}</Styled.ContentBox>        
                            )
                        })}
                    </Styled.ConTentWrap>
                    <Styled.Footer>
                        <Styled.CallBtn 
                            isActive={Choice !== ""}
                            onClick={() => {
                                if(Choice === "직접입력"){
                                    // 다른 페이지로 이동
                                    navigate(`/calldetail`)
                                }else{
                                    CallApi()
                                }
                            }}
                        >
                            <Styled.BtnText>{SelectBtn[NowLang]}</Styled.BtnText>
                        </Styled.CallBtn>
                    </Styled.Footer>
                </Styled.WrapBox>
            </>
        )
    }
    
}
export default CallService